import React from 'react';
import {
  useMediaQuery,
  Container,
  Link,
  Typography,
  Stack
} from '@mui/material';

// ==============================|| FOOTER - AUTHENTICATION ||============================== //

const AuthFooter = () => {
  const matchDownSM = useMediaQuery((theme:any) => theme.breakpoints.down('sm'));

  return (
    <Container maxWidth="xl">
      <Stack
        direction={matchDownSM ? 'column' : 'row'}
        justifyContent={matchDownSM ? 'center' : 'space-between'}
        spacing={2}
        textAlign={matchDownSM ? 'center' : 'inherit'}
      >
        <Typography variant="subtitle2" color="secondary" component="span">
          &copy; Valital Technologies INC&nbsp;
        </Typography>

        <Stack
          direction={matchDownSM ? 'column' : 'row'}
          spacing={matchDownSM ? 1 : 3}
          textAlign={matchDownSM ? 'center' : 'inherit'}
        >
          <Typography
            variant="subtitle2"
            color="secondary"
            component={Link}
            href="https://www.valital.com/"
            target="_blank"
            underline="hover"
          >
           Book a demo
          </Typography>
          <Typography
            variant="subtitle2"
            color="secondary"
            component={Link}
            href="https://company.valital.com"
            target="_blank"
            underline="hover"
          >
            Platform
          </Typography>
        </Stack>
      </Stack>
    </Container>
  );
};

export default AuthFooter;
